// Composable for Leaflet map icons (converted from mapIcons.js mixin)
import { icon } from "leaflet";

export function useMapIcons() {
  const satelliteIconNT = icon({
    iconUrl: `${process.env.VUE_APP_STATIC_HOST}/sat_recNT.png`,
    iconSize: [16, 16],
    iconAnchor: [8, 8]
  });
  const satelliteIcon1 = icon({
    iconUrl: `${process.env.VUE_APP_STATIC_HOST}/sat_rec1.png`,
    iconSize: [16, 16],
    iconAnchor: [8, 8]
  });
  const satelliteIcon2 = icon({
    iconUrl: `${process.env.VUE_APP_STATIC_HOST}/sat_rec2.png`,
    iconSize: [16, 16],
    iconAnchor: [8, 8]
  });
  const satelliteIcon3 = icon({
    iconUrl: `${process.env.VUE_APP_STATIC_HOST}/sat_rec3.png`,
    iconSize: [16, 16],
    iconAnchor: [8, 8]
  });
  const satelliteIcon4 = icon({
    iconUrl: `${process.env.VUE_APP_STATIC_HOST}/sat_rec4.png`,
    iconSize: [16, 16],
    iconAnchor: [8, 8]
  });
  const satelliteIcon5 = icon({
    iconUrl: `${process.env.VUE_APP_STATIC_HOST}/sat_rec5.png`,
    iconSize: [16, 16],
    iconAnchor: [8, 8]
  });
  const satelliteIconCRC = icon({
    iconUrl: `${process.env.VUE_APP_STATIC_HOST}/sat_crc5.png`,
    iconSize: [16, 16],
    iconAnchor: [8, 8]
  });
  const stationActiveIcon = icon({
    iconUrl: `${process.env.VUE_APP_STATIC_HOST}/station_icon_green.png`,
    iconSize: [32, 32],
    iconAnchor: [16, 16]
  });
  const stationErrorIcon = icon({
    iconUrl: `${process.env.VUE_APP_STATIC_HOST}/station_icon_orange.png`,
    iconSize: [32, 32],
    iconAnchor: [16, 16]
  });

  return {
    satelliteIconNT,
    satelliteIcon1,
    satelliteIcon2,
    satelliteIcon3,
    satelliteIcon4,
    satelliteIcon5,
    satelliteIconCRC,
    stationActiveIcon,
    stationErrorIcon
  };
}